import   React        ,
       { useEffect    }  from 'react';

import   classNames   from 'classnames';

import   styles        from './payment_result.module.scss';

import { useNavigate }  from 'react-router-dom';

import { notifyPaymentResultToOpener }  from '../../../utils/utils_paymentPopup';

// Retour PayPal/Stripe après un paiement (ou abonnement) réussi, initié depuis
// admin-front (purchaseManagment / subscriptionManagment). Le paiement lui-même est déjà
// validé côté serveur (webhook, indépendant de cette page) — cet écran ne fait que le dire.
//
// Chargée dans une fenêtre à part (cf. utils_paymentPopup.ts) : window.opener référence
// alors l'onglet admin-front d'origine, qu'on prévient puis referme automatiquement, SANS
// jamais faire naviguer cet onglet — il reste exactement où il était (pas de rechargement
// de la SPA, donc pas de reconnexion imposée). Si la fenêtre a été ouverte autrement (lien
// copié, popup bloquée par le navigateur), window.opener est absent : on garde alors le
// bouton de repli vers /bureau, seul moyen de revenir à l'app dans ce cas.
export const PaymentSuccess: React.FC = () => {

  const navigate = useNavigate();

  const openedAsPopup = !!window.opener;

  useEffect(() => {
    if (!openedAsPopup) return;

    notifyPaymentResultToOpener('success');

    const timer = setTimeout(() => window.close(), 1500);
    return () => clearTimeout(timer);
  }, [openedAsPopup]);

  return (
    <div className={classNames(styles.root)}>
      <div className={classNames(styles.contain)}>
        <div className={classNames(styles.title)}>Paiement confirmé</div>
        <div className={classNames(styles.text)}>Merci, votre achat a bien été enregistré.</div>
        {
          openedAsPopup
          ? <div className={classNames(styles.text)}>Cette fenêtre va se refermer.</div>
          : (
            <button className={classNames(styles.button)} onClick={() => navigate('/bureau')}>
              Retour à mes achats
            </button>
          )
        }
      </div>
    </div>
  );
};

export default PaymentSuccess;
